/*Global*/
import logo from '../assets/Logo/Logo.png';

/*Home*/
import home from '../assets/Home/Home.jpg';

/*Sponsors*/
import sponsor1 from '../assets/Sponsors/Sponsor-1.png';
import sponsor2 from '../assets/Sponsors/Sponsor-2.png';
import sponsor3 from '../assets/Sponsors/Sponsor-3.png';
import sponsor4 from '../assets/Sponsors/Sponsor-4.png';
import sponsor5 from '../assets/Sponsors/Sponsor-5.png';
import sponsor6 from '../assets/Sponsors/Sponsor-6.png';
import sponsor7 from '../assets/Sponsors/Sponsor-7.png';
import sponsor8 from '../assets/Sponsors/Sponsor-8.png';


/*About*/ 
import about1 from '../assets/About/About-1.jpg';
import about2 from '../assets/About/About-2.jpg';
import about3 from '../assets/About/About-3.jpg';


/*Team*/
import team1 from '../assets/Team/Team-1.jpg';
import team2 from '../assets/Team/Team-2.jpg';
import team3 from '../assets/Team/Team-3.jpg';
import team4 from '../assets/Team/Team-4.jpg';


/*Testimonials*/
import testimonial1 from '../assets/Testimonials/Pic-1.jpg';
import testimonial2 from '../assets/Testimonials/Pic-2.jpg';
import testimonial3 from '../assets/Testimonials/Pic-3.jpg';
import testimonial4 from '../assets/Testimonials/Pic-4.jpg';


/*FAQs*/
import FAQs from '../assets/FAQs/FAQs.jpg';


/*Gallery*/
import gallery1 from '../assets/Gallery/Gallery-1.jpg';
import gallery2 from '../assets/Gallery/Gallery-2.jpg';
import gallery3 from '../assets/Gallery/Gallery-3.jpg';
import gallery4 from '../assets/Gallery/Gallery-4.jpg';
import gallery5 from '../assets/Gallery/Gallery-5.jpg';
import gallery6 from '../assets/Gallery/Gallery-6.jpg';
import gallery7 from '../assets/Gallery/Gallery-7.jpg';
import gallery8 from '../assets/Gallery/Gallery-8.jpg';


/*Portfolio*/
import portfolio1 from '../assets/Portfolio/Portfolio/Portfolio-1.jpg';
import portfolio1Gallery1 from '../assets/Portfolio/Gallery/1.jpg';
import portfolio1Gallery2 from '../assets/Portfolio/Gallery/2.jpg';
import portfolio1Gallery3 from '../assets/Portfolio/Gallery/3.jpg';
import portfolio1Gallery4 from '../assets/Portfolio/Gallery/4.jpg';
import portfolio1Gallery5 from '../assets/Portfolio/Gallery/5.jpg';
import portfolio1Gallery6 from '../assets/Portfolio/Gallery/6.jpg';

import portfolio2 from '../assets/Portfolio/Portfolio/Portfolio-2.jpg';
import portfolio2Gallery1 from '../assets/Portfolio/Gallery/1.jpg';
import portfolio2Gallery2 from '../assets/Portfolio/Gallery/2.jpg';
import portfolio2Gallery3 from '../assets/Portfolio/Gallery/3.jpg';
import portfolio2Gallery4 from '../assets/Portfolio/Gallery/4.jpg';
import portfolio2Gallery5 from '../assets/Portfolio/Gallery/5.jpg';
import portfolio2Gallery6 from '../assets/Portfolio/Gallery/6.jpg';

import portfolio3 from '../assets/Portfolio/Portfolio/Portfolio-3.jpg';
import portfolio3Gallery1 from '../assets/Portfolio/Gallery/1.jpg';
import portfolio3Gallery2 from '../assets/Portfolio/Gallery/2.jpg';
import portfolio3Gallery3 from '../assets/Portfolio/Gallery/3.jpg';
import portfolio3Gallery4 from '../assets/Portfolio/Gallery/4.jpg';
import portfolio3Gallery5 from '../assets/Portfolio/Gallery/5.jpg';
import portfolio3Gallery6 from '../assets/Portfolio/Gallery/6.jpg';

import portfolio4 from '../assets/Portfolio/Portfolio/Portfolio-4.jpg';
import portfolio4Gallery1 from '../assets/Portfolio/Gallery/1.jpg';
import portfolio4Gallery2 from '../assets/Portfolio/Gallery/2.jpg';
import portfolio4Gallery3 from '../assets/Portfolio/Gallery/3.jpg';
import portfolio4Gallery4 from '../assets/Portfolio/Gallery/4.jpg';
import portfolio4Gallery5 from '../assets/Portfolio/Gallery/5.jpg';
import portfolio4Gallery6 from '../assets/Portfolio/Gallery/6.jpg';

import portfolio5 from '../assets/Portfolio/Portfolio/Portfolio-5.jpg';
import portfolio5Gallery1 from '../assets/Portfolio/Gallery/1.jpg';
import portfolio5Gallery2 from '../assets/Portfolio/Gallery/2.jpg';
import portfolio5Gallery3 from '../assets/Portfolio/Gallery/3.jpg';
import portfolio5Gallery4 from '../assets/Portfolio/Gallery/4.jpg';
import portfolio5Gallery5 from '../assets/Portfolio/Gallery/5.jpg';
import portfolio5Gallery6 from '../assets/Portfolio/Gallery/6.jpg';

import portfolio6 from '../assets/Portfolio/Portfolio/Portfolio-6.jpg';
import portfolio6Gallery1 from '../assets/Portfolio/Gallery/1.jpg';
import portfolio6Gallery2 from '../assets/Portfolio/Gallery/2.jpg';
import portfolio6Gallery3 from '../assets/Portfolio/Gallery/3.jpg';
import portfolio6Gallery4 from '../assets/Portfolio/Gallery/4.jpg';
import portfolio6Gallery5 from '../assets/Portfolio/Gallery/5.jpg';
import portfolio6Gallery6 from '../assets/Portfolio/Gallery/6.jpg';


/*service*/
import service1 from '../assets/Service/Services/Service-1.jpg';
import service1Gallery1 from '../assets/Service/Service-Gallery/1.jpg';
import service1Gallery2 from '../assets/Service/Service-Gallery/2.jpg';

import service2 from '../assets/Service/Services/Service-2.jpg';
import service2Gallery1 from '../assets/Service/Service-Gallery/1.jpg';
import service2Gallery2 from '../assets/Service/Service-Gallery/2.jpg';

import service3 from '../assets/Service/Services/Service-3.jpg';
import service3Gallery1 from '../assets/Service/Service-Gallery/1.jpg';
import service3Gallery2 from '../assets/Service/Service-Gallery/2.jpg';

import service4 from '../assets/Service/Services/Service-4.jpg';
import service4Gallery1 from '../assets/Service/Service-Gallery/1.jpg';
import service4Gallery2 from '../assets/Service/Service-Gallery/2.jpg';

import service5 from '../assets/Service/Services/Service-5.jpg';
import service5Gallery1 from '../assets/Service/Service-Gallery/1.jpg';
import service5Gallery2 from '../assets/Service/Service-Gallery/2.jpg';

import service6 from '../assets/Service/Services/Service-6.jpg';
import service6Gallery1 from '../assets/Service/Service-Gallery/1.jpg';
import service6Gallery2 from '../assets/Service/Service-Gallery/2.jpg';


/*Venue Gallery*/
import venueGallery1 from '../assets/Venue/Gallery/1.jpg';
import venueGallery2 from '../assets/Venue/Gallery/2.jpg';
import venueGallery3 from '../assets/Venue/Gallery/3.jpg';


/*Venue Rooms*/
import venueRoom1 from '../assets/Venue/Rooms/Room-1.jpg';
import venueRoom2 from '../assets/Venue/Rooms/Room-2.jpg';
import venueRoom3 from '../assets/Venue/Rooms/Room-3.jpg';


/*Speakers*/
import speaker1 from '../assets/Speakers/Speaker-1.jpg';
import speaker2 from '../assets/Speakers/Speaker-2.jpg';
import speaker3 from '../assets/Speakers/Speaker-3.jpg';
import speaker4 from '../assets/Speakers/Speaker-4.jpg';
import speaker5 from '../assets/Speakers/Speaker-5.jpg';
import speaker6 from '../assets/Speakers/Speaker-6.jpg';
import speaker7 from '../assets/Speakers/Speaker-7.jpg';
import speaker8 from '../assets/Speakers/Speaker-8.jpg';


/*Schedule*/
import session1 from '../assets/Schedule/Sessions/Session-1.jpg';
import session1Gallery1 from '../assets/Schedule/Gallery/1.jpg';
import session1Gallery2 from '../assets/Schedule/Gallery/2.jpg';

import session2 from '../assets/Schedule/Sessions/Session-2.jpg';
import session2Gallery1 from '../assets/Schedule/Gallery/1.jpg';
import session2Gallery2 from '../assets/Schedule/Gallery/2.jpg';

import session3 from '../assets/Schedule/Sessions/Session-3.jpg';
import session3Gallery1 from '../assets/Schedule/Gallery/1.jpg';
import session3Gallery2 from '../assets/Schedule/Gallery/2.jpg';

import session4 from '../assets/Schedule/Sessions/Session-4.jpg';
import session4Gallery1 from '../assets/Schedule/Gallery/1.jpg';
import session4Gallery2 from '../assets/Schedule/Gallery/2.jpg';

import session5 from '../assets/Schedule/Sessions/Session-5.jpg';
import session5Gallery1 from '../assets/Schedule/Gallery/1.jpg';
import session5Gallery2 from '../assets/Schedule/Gallery/2.jpg';

import session6 from '../assets/Schedule/Sessions/Session-6.jpg';
import session6Gallery1 from '../assets/Schedule/Gallery/1.jpg';
import session6Gallery2 from '../assets/Schedule/Gallery/2.jpg';

import session7 from '../assets/Schedule/Sessions/Session-7.jpg';
import session7Gallery1 from '../assets/Schedule/Gallery/1.jpg';
import session7Gallery2 from '../assets/Schedule/Gallery/2.jpg';

import session8 from '../assets/Schedule/Sessions/Session-8.jpg';
import session8Gallery1 from '../assets/Schedule/Gallery/1.jpg';
import session8Gallery2 from '../assets/Schedule/Gallery/2.jpg';

import session9 from '../assets/Schedule/Sessions/Session-9.jpg';
import session9Gallery1 from '../assets/Schedule/Gallery/1.jpg';
import session9Gallery2 from '../assets/Schedule/Gallery/2.jpg';

import session10 from '../assets/Schedule/Sessions/Session-10.jpg';
import session10Gallery1 from '../assets/Schedule/Gallery/1.jpg';
import session10Gallery2 from '../assets/Schedule/Gallery/2.jpg';

import session11 from '../assets/Schedule/Sessions/Session-11.jpg';
import session11Gallery1 from '../assets/Schedule/Gallery/1.jpg';
import session11Gallery2 from '../assets/Schedule/Gallery/2.jpg';

import session12 from '../assets/Schedule/Sessions/Session-12.jpg';
import session12Gallery1 from '../assets/Schedule/Gallery/1.jpg';
import session12Gallery2 from '../assets/Schedule/Gallery/2.jpg';

/*Blogs*/
import blog1 from '../assets/Blog/Blogs/Blog-1.jpg';
import blog1Gallery1 from '../assets/Blog/Blog-Gallery/1.jpg';
import blog1Gallery2 from '../assets/Blog/Blog-Gallery/2.jpg';
import blog1Comment1 from '../assets/Blog/Comments/Pic-1.jpg';
import blog1Comment2 from '../assets/Blog/Comments/Pic-2.jpg';
import blog1Comment3 from '../assets/Blog/Comments/Pic-3.jpg';

import blog2 from '../assets/Blog/Blogs/Blog-2.jpg';
import blog2Gallery1 from '../assets/Blog/Blog-Gallery/1.jpg';
import blog2Gallery2 from '../assets/Blog/Blog-Gallery/2.jpg';
import blog2Comment1 from '../assets/Blog/Comments/Pic-1.jpg';
import blog2Comment2 from '../assets/Blog/Comments/Pic-2.jpg';
import blog2Comment3 from '../assets/Blog/Comments/Pic-3.jpg';

import blog3 from '../assets/Blog/Blogs/Blog-3.jpg';
import blog3Gallery1 from '../assets/Blog/Blog-Gallery/1.jpg';
import blog3Gallery2 from '../assets/Blog/Blog-Gallery/2.jpg';
import blog3Comment1 from '../assets/Blog/Comments/Pic-1.jpg';
import blog3Comment2 from '../assets/Blog/Comments/Pic-2.jpg';
import blog3Comment3 from '../assets/Blog/Comments/Pic-3.jpg';

import blog4 from '../assets/Blog/Blogs/Blog-4.jpg';
import blog4Gallery1 from '../assets/Blog/Blog-Gallery/1.jpg';
import blog4Gallery2 from '../assets/Blog/Blog-Gallery/2.jpg';
import blog4Comment1 from '../assets/Blog/Comments/Pic-1.jpg';
import blog4Comment2 from '../assets/Blog/Comments/Pic-2.jpg';
import blog4Comment3 from '../assets/Blog/Comments/Pic-3.jpg';

import blog5 from '../assets/Blog/Blogs/Blog-5.jpg';
import blog5Gallery1 from '../assets/Blog/Blog-Gallery/1.jpg';
import blog5Gallery2 from '../assets/Blog/Blog-Gallery/2.jpg';
import blog5Comment1 from '../assets/Blog/Comments/Pic-1.jpg';
import blog5Comment2 from '../assets/Blog/Comments/Pic-2.jpg';
import blog5Comment3 from '../assets/Blog/Comments/Pic-3.jpg';

import blog6 from '../assets/Blog/Blogs/Blog-6.jpg';
import blog6Gallery1 from '../assets/Blog/Blog-Gallery/1.jpg';
import blog6Gallery2 from '../assets/Blog/Blog-Gallery/2.jpg';
import blog6Comment1 from '../assets/Blog/Comments/Pic-1.jpg';
import blog6Comment2 from '../assets/Blog/Comments/Pic-2.jpg';
import blog6Comment3 from '../assets/Blog/Comments/Pic-3.jpg';

import blog7 from '../assets/Blog/Blogs/Blog-7.jpg';
import blog7Gallery1 from '../assets/Blog/Blog-Gallery/1.jpg';
import blog7Gallery2 from '../assets/Blog/Blog-Gallery/2.jpg';
import blog7Comment1 from '../assets/Blog/Comments/Pic-1.jpg';
import blog7Comment2 from '../assets/Blog/Comments/Pic-2.jpg';
import blog7Comment3 from '../assets/Blog/Comments/Pic-3.jpg';

import blog8 from '../assets/Blog/Blogs/Blog-8.jpg';
import blog8Gallery1 from '../assets/Blog/Blog-Gallery/1.jpg';
import blog8Gallery2 from '../assets/Blog/Blog-Gallery/2.jpg';
import blog8Comment1 from '../assets/Blog/Comments/Pic-1.jpg';
import blog8Comment2 from '../assets/Blog/Comments/Pic-2.jpg';
import blog8Comment3 from '../assets/Blog/Comments/Pic-3.jpg';

import blog9 from '../assets/Blog/Blogs/Blog-9.jpg';
import blog9Gallery1 from '../assets/Blog/Blog-Gallery/1.jpg';
import blog9Gallery2 from '../assets/Blog/Blog-Gallery/2.jpg';
import blog9Comment1 from '../assets/Blog/Comments/Pic-1.jpg';
import blog9Comment2 from '../assets/Blog/Comments/Pic-2.jpg';
import blog9Comment3 from '../assets/Blog/Comments/Pic-3.jpg';

import blog10 from '../assets/Blog/Blogs/Blog-10.jpg';
import blog10Gallery1 from '../assets/Blog/Blog-Gallery/1.jpg';
import blog10Gallery2 from '../assets/Blog/Blog-Gallery/2.jpg';
import blog10Comment1 from '../assets/Blog/Comments/Pic-1.jpg';
import blog10Comment2 from '../assets/Blog/Comments/Pic-2.jpg';
import blog10Comment3 from '../assets/Blog/Comments/Pic-3.jpg';

import blog11 from '../assets/Blog/Blogs/Blog-11.jpg';
import blog11Gallery1 from '../assets/Blog/Blog-Gallery/1.jpg';
import blog11Gallery2 from '../assets/Blog/Blog-Gallery/2.jpg';
import blog11Comment1 from '../assets/Blog/Comments/Pic-1.jpg';
import blog11Comment2 from '../assets/Blog/Comments/Pic-2.jpg';
import blog11Comment3 from '../assets/Blog/Comments/Pic-3.jpg';

import blog12 from '../assets/Blog/Blogs/Blog-12.jpg';
import blog12Gallery1 from '../assets/Blog/Blog-Gallery/1.jpg';
import blog12Gallery2 from '../assets/Blog/Blog-Gallery/2.jpg';
import blog12Comment1 from '../assets/Blog/Comments/Pic-1.jpg';
import blog12Comment2 from '../assets/Blog/Comments/Pic-2.jpg';
import blog12Comment3 from '../assets/Blog/Comments/Pic-3.jpg';

/*Shop*/
import product1Gallery1 from '../assets/Shop/Products/1.jpg';
import product1Gallery2 from '../assets/Shop/Products/2.jpg';
import product1Gallery3 from '../assets/Shop/Products/3.jpg';
import product1Gallery4 from '../assets/Shop/Products/4.jpg';
import product1Review1 from '../assets/Shop/Reviews/Pic-1.jpg';
import product1Review2 from '../assets/Shop/Reviews/Pic-2.jpg';

import product2Gallery1 from '../assets/Shop/Products/2.jpg';
import product2Gallery2 from '../assets/Shop/Products/3.jpg';
import product2Gallery3 from '../assets/Shop/Products/4.jpg';
import product2Gallery4 from '../assets/Shop/Products/5.jpg';
import product2Review1 from '../assets/Shop/Reviews/Pic-1.jpg';
import product2Review2 from '../assets/Shop/Reviews/Pic-2.jpg';

import product3Gallery1 from '../assets/Shop/Products/3.jpg';
import product3Gallery2 from '../assets/Shop/Products/4.jpg';
import product3Gallery3 from '../assets/Shop/Products/5.jpg';
import product3Gallery4 from '../assets/Shop/Products/6.jpg';
import product3Review1 from '../assets/Shop/Reviews/Pic-1.jpg';
import product3Review2 from '../assets/Shop/Reviews/Pic-2.jpg';

import product4Gallery1 from '../assets/Shop/Products/4.jpg';
import product4Gallery2 from '../assets/Shop/Products/5.jpg';
import product4Gallery3 from '../assets/Shop/Products/6.jpg';
import product4Gallery4 from '../assets/Shop/Products/7.jpg';
import product4Review1 from '../assets/Shop/Reviews/Pic-1.jpg';
import product4Review2 from '../assets/Shop/Reviews/Pic-2.jpg';

import product5Gallery1 from '../assets/Shop/Products/5.jpg';
import product5Gallery2 from '../assets/Shop/Products/6.jpg';
import product5Gallery3 from '../assets/Shop/Products/7.jpg';
import product5Gallery4 from '../assets/Shop/Products/8.jpg';
import product5Review1 from '../assets/Shop/Reviews/Pic-1.jpg';
import product5Review2 from '../assets/Shop/Reviews/Pic-2.jpg';

import product6Gallery1 from '../assets/Shop/Products/6.jpg';
import product6Gallery2 from '../assets/Shop/Products/7.jpg';
import product6Gallery3 from '../assets/Shop/Products/8.jpg';
import product6Gallery4 from '../assets/Shop/Products/9.jpg';
import product6Review1 from '../assets/Shop/Reviews/Pic-1.jpg';
import product6Review2 from '../assets/Shop/Reviews/Pic-2.jpg';

import product7Gallery1 from '../assets/Shop/Products/7.jpg';
import product7Gallery2 from '../assets/Shop/Products/8.jpg';
import product7Gallery3 from '../assets/Shop/Products/9.jpg';
import product7Gallery4 from '../assets/Shop/Products/10.jpg';
import product7Review1 from '../assets/Shop/Reviews/Pic-1.jpg';
import product7Review2 from '../assets/Shop/Reviews/Pic-2.jpg';

import product8Gallery1 from '../assets/Shop/Products/8.jpg';
import product8Gallery2 from '../assets/Shop/Products/9.jpg';
import product8Gallery3 from '../assets/Shop/Products/10.jpg';
import product8Gallery4 from '../assets/Shop/Products/11.jpg';
import product8Review1 from '../assets/Shop/Reviews/Pic-1.jpg';
import product8Review2 from '../assets/Shop/Reviews/Pic-2.jpg';

import product9Gallery1 from '../assets/Shop/Products/9.jpg';
import product9Gallery2 from '../assets/Shop/Products/10.jpg';
import product9Gallery3 from '../assets/Shop/Products/11.jpg';
import product9Gallery4 from '../assets/Shop/Products/12.jpg';
import product9Review1 from '../assets/Shop/Reviews/Pic-1.jpg';
import product9Review2 from '../assets/Shop/Reviews/Pic-2.jpg';

import product10Gallery1 from '../assets/Shop/Products/10.jpg';
import product10Gallery2 from '../assets/Shop/Products/11.jpg';
import product10Gallery3 from '../assets/Shop/Products/12.jpg';
import product10Gallery4 from '../assets/Shop/Products/13.jpg';
import product10Review1 from '../assets/Shop/Reviews/Pic-1.jpg';
import product10Review2 from '../assets/Shop/Reviews/Pic-2.jpg';

import product11Gallery1 from '../assets/Shop/Products/11.jpg';
import product11Gallery2 from '../assets/Shop/Products/12.jpg';
import product11Gallery3 from '../assets/Shop/Products/13.jpg';
import product11Gallery4 from '../assets/Shop/Products/14.jpg';
import product11Review1 from '../assets/Shop/Reviews/Pic-1.jpg';
import product11Review2 from '../assets/Shop/Reviews/Pic-2.jpg';

import product12Gallery1 from '../assets/Shop/Products/12.jpg';
import product12Gallery2 from '../assets/Shop/Products/13.jpg';
import product12Gallery3 from '../assets/Shop/Products/14.jpg';
import product12Gallery4 from '../assets/Shop/Products/1.jpg';
import product12Review1 from '../assets/Shop/Reviews/Pic-1.jpg';
import product12Review2 from '../assets/Shop/Reviews/Pic-2.jpg';

import product13Gallery1 from '../assets/Shop/Products/13.jpg';
import product13Gallery2 from '../assets/Shop/Products/14.jpg';
import product13Gallery3 from '../assets/Shop/Products/1.jpg';
import product13Gallery4 from '../assets/Shop/Products/2.jpg';
import product13Review1 from '../assets/Shop/Reviews/Pic-1.jpg';
import product13Review2 from '../assets/Shop/Reviews/Pic-2.jpg';

import product14Gallery1 from '../assets/Shop/Products/14.jpg';
import product14Gallery2 from '../assets/Shop/Products/1.jpg';
import product14Gallery3 from '../assets/Shop/Products/2.jpg';
import product14Gallery4 from '../assets/Shop/Products/3.jpg';
import product14Review1 from '../assets/Shop/Reviews/Pic-1.jpg';
import product14Review2 from '../assets/Shop/Reviews/Pic-2.jpg';



const images = {

    /*Global*/
    logo,

    /*Home*/
    home,

    /*sponsors*/
    sponsor1,
    sponsor2,
    sponsor3,
    sponsor4,
    sponsor5,
    sponsor6,
    sponsor7,
    sponsor8,

    /*About*/
    about1,
    about2,
    about3,

    /*Team*/
    team1,
    team2,
    team3, 
    team4,

    /*Speakers*/
    speaker1,
    speaker2,
    speaker3,
    speaker4,
    speaker5,
    speaker6,
    speaker7,
    speaker8,

    /*Testimonials*/
    testimonial1,
    testimonial2,
    testimonial3,
    testimonial4,

    /*FAQs*/ 
    FAQs,

    /*Gallery*/
    gallery1,
    gallery2,
    gallery3,
    gallery4,
    gallery5,
    gallery6,
    gallery7,
    gallery8,

    session1,
    session1Gallery1,
    session1Gallery2,

    session2,
    session2Gallery1,
    session2Gallery2,

    session3,
    session3Gallery1,
    session3Gallery2,

    session4,
    session4Gallery1,
    session4Gallery2,

    session5,
    session5Gallery1,
    session5Gallery2,

    session6,
    session6Gallery1,
    session6Gallery2,

    session7,
    session7Gallery1,
    session7Gallery2,

    session8,
    session8Gallery1,
    session8Gallery2,

    session9,
    session9Gallery1,
    session9Gallery2,

    session10,
    session10Gallery1,
    session10Gallery2,

    session11,
    session11Gallery1,
    session11Gallery2,

    session12,
    session12Gallery1,
    session12Gallery2,

    /*Venue Gallery*/
    venueGallery1,
    venueGallery2,
    venueGallery3,


    /*Venue Rooms*/
    venueRoom1,
    venueRoom2,
    venueRoom3,


    /*service*/
    service1,
    service1Gallery1,
    service1Gallery2,

    service2,
    service2Gallery1,
    service2Gallery2,

    service3,
    service3Gallery1,
    service3Gallery2,

    service4,
    service4Gallery1,
    service4Gallery2,

    service5,
    service5Gallery1,
    service5Gallery2,

    service6,
    service6Gallery1,
    service6Gallery2,

    /*portfolio*/
    portfolio1,
    portfolio1Gallery1,
    portfolio1Gallery2,
    portfolio1Gallery3,
    portfolio1Gallery4,
    portfolio1Gallery5,
    portfolio1Gallery6,

    portfolio2,
    portfolio2Gallery1,
    portfolio2Gallery2,
    portfolio2Gallery3,
    portfolio2Gallery4,
    portfolio2Gallery5,
    portfolio2Gallery6,

    portfolio3,
    portfolio3Gallery1,
    portfolio3Gallery2,
    portfolio3Gallery3,
    portfolio3Gallery4,
    portfolio3Gallery5,
    portfolio3Gallery6,

    portfolio4,
    portfolio4Gallery1,
    portfolio4Gallery2,
    portfolio4Gallery3,
    portfolio4Gallery4,
    portfolio4Gallery5,
    portfolio4Gallery6,

    portfolio5,
    portfolio5Gallery1,
    portfolio5Gallery2,
    portfolio5Gallery3,
    portfolio5Gallery4,
    portfolio5Gallery5,
    portfolio5Gallery6,

    portfolio6,
    portfolio6Gallery1,
    portfolio6Gallery2,
    portfolio6Gallery3,
    portfolio6Gallery4,
    portfolio6Gallery5,
    portfolio6Gallery6,

    /*Blogs*/
    blog1,
    blog1Gallery1,
    blog1Gallery2,
    blog1Comment1,
    blog1Comment2,
    blog1Comment3,

    blog2,
    blog2Gallery1,
    blog2Gallery2,
    blog2Comment1,
    blog2Comment2,
    blog2Comment3,

    blog3,
    blog3Gallery1,
    blog3Gallery2,
    blog3Comment1,
    blog3Comment2,
    blog3Comment3,

    blog4,
    blog4Gallery1,
    blog4Gallery2,
    blog4Comment1,
    blog4Comment2,
    blog4Comment3,

    blog5,
    blog5Gallery1,
    blog5Gallery2,
    blog5Comment1,
    blog5Comment2,
    blog5Comment3,

    blog6,
    blog6Gallery1,
    blog6Gallery2,
    blog6Comment1,
    blog6Comment2,
    blog6Comment3,

    blog7,
    blog7Gallery1,
    blog7Gallery2,
    blog7Comment1,
    blog7Comment2,
    blog7Comment3,

    blog8,
    blog8Gallery1,
    blog8Gallery2,
    blog8Comment1,
    blog8Comment2,
    blog8Comment3,

    blog9,
    blog9Gallery1,
    blog9Gallery2,
    blog9Comment1,
    blog9Comment2,
    blog9Comment3,

    blog10,
    blog10Gallery1,
    blog10Gallery2,
    blog10Comment1,
    blog10Comment2,
    blog10Comment3,

    blog11,
    blog11Gallery1,
    blog11Gallery2,
    blog11Comment1,
    blog11Comment2,
    blog11Comment3,

    blog12,
    blog12Gallery1,
    blog12Gallery2,
    blog12Comment1,
    blog12Comment2,
    blog12Comment3,

    /*Shop*/
    product1Gallery1,
    product1Gallery2,
    product1Gallery3, 
    product1Gallery4,
    product1Review1,
    product1Review2,

    product2Gallery1,
    product2Gallery2,
    product2Gallery3,
    product2Gallery4,
    product2Review1,
    product2Review2,

    product3Gallery1,
    product3Gallery2,
    product3Gallery3,
    product3Gallery4,
    product3Review1,
    product3Review2,

    product4Gallery1,
    product4Gallery2,
    product4Gallery3,
    product4Gallery4,
    product4Review1,
    product4Review2,

    product5Gallery1,
    product5Gallery2,
    product5Gallery3,
    product5Gallery4,
    product5Review1,
    product5Review2,

    product6Gallery1,
    product6Gallery2,
    product6Gallery3,
    product6Gallery4,
    product6Review1,
    product6Review2,

    product7Gallery1,
    product7Gallery2,
    product7Gallery3,
    product7Gallery4,
    product7Review1,
    product7Review2,

    product8Gallery1,
    product8Gallery2,
    product8Gallery3,
    product8Gallery4,
    product8Review1,
    product8Review2,

    product9Gallery1,
    product9Gallery2,
    product9Gallery3,
    product9Gallery4,
    product9Review1,
    product9Review2,

    product10Gallery1,
    product10Gallery2,
    product10Gallery3,
    product10Gallery4,
    product10Review1,
    product10Review2,

    product11Gallery1,
    product11Gallery2,
    product11Gallery3,
    product11Gallery4,
    product11Review1,
    product11Review2,

    product12Gallery1,
    product12Gallery2,
    product12Gallery3,
    product12Gallery4,
    product12Review1,
    product12Review2,

    product13Gallery1,
    product13Gallery2,
    product13Gallery3,
    product13Gallery4,
    product13Review1,
    product13Review2,

    product14Gallery1,
    product14Gallery2,
    product14Gallery3,
    product14Gallery4,
    product14Review1,
    product14Review2,

};

export default images;